import { FunctionComponent, SVGProps } from 'react';

import { ReactComponent as ArrowSplit } from 'assets/images/icons/arrow-split.svg';
import { ReactComponent as DownloadRounded } from 'assets/images/icons/downloadRounded.svg';
import { ReactComponent as EmptySectionSitting } from 'assets/images/icons/empty-section-sitting.svg';
import { ReactComponent as EmptySectionStanding } from 'assets/images/icons/empty-section-standing.svg';
import { ReactComponent as GridCompany } from 'assets/images/icons/company-primary.svg';
import { ReactComponent as GridHealthcare } from 'assets/images/icons/platform-grid.svg';
import { ReactComponent as IconActivity } from 'assets/images/icons/activity.svg';
import { ReactComponent as IconAdd } from 'assets/images/icons/add.svg';
import { ReactComponent as IconAddCircle } from 'assets/images/icons/add-circle.svg';
import { ReactComponent as IconAlias } from 'assets/images/icons/alias.svg';
import { ReactComponent as IconAliases } from 'assets/images/icons/aliases.svg';
import { ReactComponent as IconArrowDown } from 'assets/images/icons/arrow-down.svg';
import { ReactComponent as IconArrowForwardRight } from 'assets/images/icons/arrow-forward-right.svg';
import { ReactComponent as IconArrowLeft } from 'assets/images/icons/arrow-left.svg';
import { ReactComponent as IconArrowRight } from 'assets/images/icons/arrow-right.svg';
import { ReactComponent as IconArrowUp } from 'assets/images/icons/arrow-up.svg';
import { ReactComponent as IconAttributes } from 'assets/images/icons/attributes.svg';
import { ReactComponent as IconBalloon } from 'assets/images/icons/balloon.svg';
import { ReactComponent as IconBedroom } from 'assets/images/icons/bedroom.svg';
import { ReactComponent as IconBoard } from 'assets/images/icons/board.svg';
import { ReactComponent as IconBriefcase } from 'assets/images/icons/briefcase.svg';
import { ReactComponent as IconBuilding } from 'assets/images/icons/building.svg';
import { ReactComponent as IconBuildingMedia } from 'assets/images/icons/building-media.svg';
import { ReactComponent as IconBuildings } from 'assets/images/icons/buildings.svg';
import { ReactComponent as IconBusFront } from 'assets/images/icons/bus-front.svg';
import { ReactComponent as IconCheck } from 'assets/images/icons/check.svg';
import { ReactComponent as IconClear } from 'assets/images/icons/clear.svg';
import { ReactComponent as IconClose } from 'assets/images/icons/close.svg';
import { ReactComponent as IconCoffee } from 'assets/images/icons/coffee.svg';
import { ReactComponent as IconComment } from 'assets/images/icons/comment.svg';
import { ReactComponent as IconCompany } from 'assets/images/icons/company.svg';
import { ReactComponent as IconComparative } from 'assets/images/icons/comparative.svg';
import { ReactComponent as IconCompass } from 'assets/images/icons/compass.svg';
import { ReactComponent as IconConversion } from 'assets/images/icons/conversion.svg';
import { ReactComponent as IconCrossHair } from 'assets/images/icons/crosshair.svg';
import { ReactComponent as IconDelete } from 'assets/images/icons/delete.svg';
import { ReactComponent as IconDoubleDash } from 'assets/images/icons/double-dash.svg';
import { ReactComponent as IconDownload } from 'assets/images/icons/download.svg';
import { ReactComponent as IconDarkerAttributes } from 'assets/images/icons/empty-section.svg';
import { ReactComponent as IconEarthMarker } from 'assets/images/icons/earth-marker.svg';
import { ReactComponent as IconEdit } from 'assets/images/icons/edit.svg';
import { ReactComponent as IconExclude } from 'assets/images/icons/exclude.svg';
import { ReactComponent as IconExplore } from 'assets/images/icons/explore.svg';
import { ReactComponent as IconFile } from 'assets/images/icons/file.svg';
import { ReactComponent as IconFind } from 'assets/images/icons/find.svg';
import { ReactComponent as IconFundamentals } from 'assets/images/icons/fundamentals.svg';
import { ReactComponent as IconGrid } from 'assets/images/icons/grid.svg';
import { ReactComponent as IconGridLarge } from 'assets/images/icons/grid-large.svg';
import { ReactComponent as IconInfo } from 'assets/images/icons/info.svg';
import { ReactComponent as IconInfoOutline } from 'assets/images/icons/info-outline.svg';
import { ReactComponent as IconInvestor } from 'assets/images/icons/investor.svg';
import { ReactComponent as IconKpiArrowDown } from 'assets/images/icons/arrow-kpi-down.svg';
import { ReactComponent as IconKpiArrowUp } from 'assets/images/icons/arrow-kpi-up.svg';
import { ReactComponent as IconLeasing } from 'assets/images/icons/leasing.svg';
import { ReactComponent as IconLeasingTrends } from 'assets/images/icons/leasing-trends.svg';
import { ReactComponent as IconLink } from 'assets/images/icons/link.svg';
import { ReactComponent as IconList } from 'assets/images/icons/list.svg';
import { ReactComponent as IconMap } from 'assets/images/icons/map.svg';
import { ReactComponent as IconMapMarker } from 'assets/images/icons/map-marker.svg';
import { ReactComponent as IconMapPin } from 'assets/images/icons/map-pin.svg';
import { ReactComponent as IconMapPinDark } from 'assets/images/icons/map-pin-dark.svg';
import { ReactComponent as IconMerge } from 'assets/images/icons/merge.svg';
import { ReactComponent as IconMinus } from 'assets/images/icons/minus.svg';
import { ReactComponent as IconMore } from 'assets/images/icons/more.svg';
import { ReactComponent as IconNearbyAmenities } from 'assets/images/icons/nearby-amenities.svg';
import { ReactComponent as IconNote } from 'assets/images/icons/note.svg';
import { ReactComponent as IconOccupier } from 'assets/images/icons/occupier.svg';
import { ReactComponent as IconPerformance } from 'assets/images/icons/performance.svg';
import { ReactComponent as IconPlus } from 'assets/images/icons/plus.svg';
import { ReactComponent as IconPrivacy } from 'assets/images/icons/privacy.svg';
import { ReactComponent as IconProfilePicture } from 'assets/images/icons/profile-picture.svg';
import { ReactComponent as IconRanking } from 'assets/images/icons/ranking.svg';
import { ReactComponent as IconRecreationParks } from 'assets/images/icons/recreation-parks.svg';
import { ReactComponent as IconRectangle } from 'assets/images/icons/rectangle.svg';
import { ReactComponent as IconSale } from 'assets/images/icons/sale.svg';
import { ReactComponent as IconSchools } from 'assets/images/icons/schools.svg';
import { ReactComponent as IconSearch } from 'assets/images/icons/search-grey-64.svg';
import { ReactComponent as IconSend } from 'assets/images/icons/send.svg';
import { ReactComponent as IconShare } from 'assets/images/icons/share.svg';
import { ReactComponent as IconSpaces } from 'assets/images/icons/spaces.svg';
import { ReactComponent as IconStack } from 'assets/images/icons/stack.svg';
import { ReactComponent as IconStar } from 'assets/images/icons/star.svg';
import { ReactComponent as IconStars } from 'assets/images/icons/stars.svg';
import { ReactComponent as IconStarsCircle } from 'assets/images/icons/stars-circle.svg';
import { ReactComponent as IconTemple } from 'assets/images/icons/temple.svg';
import { ReactComponent as IconTenantProspect } from 'assets/images/icons/tenant-prospect.svg';
import { ReactComponent as IconTertiaryPoint } from 'assets/images/icons/tertiary-point.svg';
import { ReactComponent as IconTheater } from 'assets/images/icons/theater.svg';
import { ReactComponent as IconTimes } from 'assets/images/icons/times.svg';
import { ReactComponent as IconTouring } from 'assets/images/icons/touring.svg';
import { ReactComponent as IconUpload } from 'assets/images/icons/upload.svg';
import { ReactComponent as IconUser } from 'assets/images/icons/user.svg';
import { ReactComponent as IconWalkscoreBike } from 'assets/images/icons/walkscore-bike.svg';
import { ReactComponent as IconWalkscoreCopy } from 'assets/images/icons/walkscore-copy.svg';
import { ReactComponent as IconWalkscoreTransit } from 'assets/images/icons/walkscore-transit.svg';
import { ReactComponent as IconWalkscoreWalk } from 'assets/images/icons/walkscore-walk.svg';
import { ReactComponent as IconWarning } from 'assets/images/icons/warning.svg';
import { ReactComponent as IconWorld } from 'assets/images/icons/world.svg';
import { ReactComponent as Parcel } from 'assets/images/icons/parcel.svg';
import { ReactComponent as TourOverview } from 'assets/images/icons/tour-overview.svg';

import { ReactComponent as IconBed } from 'assets/images/summary/bed.svg';
import { ReactComponent as IconBuildingSize } from 'assets/images/summary/building.svg';
import { ReactComponent as IconBuildType } from 'assets/images/summary/build-type.svg';
import { ReactComponent as IconBuilt } from 'assets/images/summary/built.svg';
import { ReactComponent as IconCar } from 'assets/images/summary/car.svg';
import { ReactComponent as IconClearHeight } from 'assets/images/summary/clear-height.svg';
import { ReactComponent as IconContiguous } from 'assets/images/summary/contiguous.svg';
import { ReactComponent as IconDevelopmentType } from 'assets/images/summary/development-type.svg';
import { ReactComponent as IconDockConfiguration } from 'assets/images/summary/dock-configuration.svg';
import { ReactComponent as IconDockDoors } from 'assets/images/summary/dock-doors.svg';
import { ReactComponent as IconFloorplate } from 'assets/images/summary/floorplate.svg';
import { ReactComponent as IconLocation } from 'assets/images/summary/location.svg';
import { ReactComponent as IconOperationalStatus } from 'assets/images/summary/operational-status.svg';
import { ReactComponent as IconOwnerOccupied } from 'assets/images/summary/owner-occupied.svg';
import { ReactComponent as IconParkingSpaces } from 'assets/images/summary/parking-spaces.svg';
import { ReactComponent as IconPower } from 'assets/images/summary/power.svg';
import { ReactComponent as IconRail } from 'assets/images/summary/rail.svg';
import { ReactComponent as IconSprinklers } from 'assets/images/summary/sprinklers.svg';
import { ReactComponent as IconStories } from 'assets/images/summary/stories.svg';
import { ReactComponent as IconTaxOpex } from 'assets/images/summary/tax-opex.svg';
import { ReactComponent as IconTenancy } from 'assets/images/summary/tenancy.svg';
import { ReactComponent as IconTrailerParking } from 'assets/images/summary/trailer-parking.svg';
import { ReactComponent as IconWalkScore } from 'assets/images/summary/walk-score.svg';
import { ReactComponent as IconZoning } from 'assets/images/summary/zoning.svg';

import CAFlag from 'assets/images/flags/ca.svg';
import DEFlag from 'assets/images/flags/de.svg';
import IEFlag from 'assets/images/flags/ie.svg';
import ILFlag from 'assets/images/flags/il.svg';
import KRFlag from 'assets/images/flags/kr.svg';
import MXFlag from 'assets/images/flags/mx.svg';
import PLFlag from 'assets/images/flags/pl.svg';
import ROFlag from 'assets/images/flags/ro.svg';
import UKFlag from 'assets/images/flags/uk.svg';
import USFlag from 'assets/images/flags/us.svg';

import GreaterCanada from 'assets/images/greaterMarkets/canada.svg';
import GreaterGermany from 'assets/images/greaterMarkets/germany.svg';
import Global from 'assets/images/greaterMarkets/global.svg';
import GreaterIreland from 'assets/images/greaterMarkets/ireland.svg';
import GreaterIsrael from 'assets/images/greaterMarkets/israel.svg';
import GreaterUK from 'assets/images/greaterMarkets/UK.svg';
import GreaterUS from 'assets/images/greaterMarkets/US.svg';
import GreaterPoland from 'assets/images/greaterMarkets/poland.svg';

export const ICONS: {
  [name: string]: FunctionComponent<SVGProps<SVGSVGElement>>;
} = {
  activity: IconActivity,
  add: IconAdd,
  addCircle: IconAddCircle,
  alias: IconAlias,
  aliases: IconAliases,
  arrowDown: IconArrowDown,
  arrowForwardRight: IconArrowForwardRight,
  arrowKpiDown: IconKpiArrowDown,
  arrowKpiUp: IconKpiArrowUp,
  arrowLeft: IconArrowLeft,
  arrowRight: IconArrowRight,
  arrowSplit: ArrowSplit,
  arrowUp: IconArrowUp,
  bed: IconBed,
  buildType: IconBuildType,
  built: IconBuilt,
  car: IconCar,
  clearHeight: IconClearHeight,
  contiguous: IconContiguous,
  developmentType: IconDevelopmentType,
  dockConfiguration: IconDockConfiguration,
  dockDoors: IconDockDoors,
  floorplate: IconFloorplate,
  operationalStatus: IconOperationalStatus,
  ownerOccupied: IconOwnerOccupied,
  parkingSpaces: IconParkingSpaces,
  power: IconPower,
  buildingSize: IconBuildingSize,
  sprinklers: IconSprinklers,
  stories: IconStories,
  stars: IconStars,
  starsCircle: IconStarsCircle,
  taxOpex: IconTaxOpex,
  tenancy: IconTenancy,
  location: IconLocation,
  trailerParking: IconTrailerParking,
  rail: IconRail,
  walkScore: IconWalkScore,
  zoning: IconZoning,
  attributes: IconAttributes,
  balloon: IconBalloon,
  bedroom: IconBedroom,
  board: IconBoard,
  briefcase: IconBriefcase,
  building: IconBuilding,
  buildings: IconBuildings,
  buildingMedia: IconBuildingMedia,
  busFront: IconBusFront,
  check: IconCheck,
  clear: IconClear,
  close: IconClose,
  coffee: IconCoffee,
  comment: IconComment,
  company: IconCompany,
  comparative: IconComparative,
  compass: IconCompass,
  conversion: IconConversion,
  crosshair: IconCrossHair,
  darkerAttributes: IconDarkerAttributes,
  delete: IconDelete,
  doubleDash: IconDoubleDash,
  download: IconDownload,
  downloadRounded: DownloadRounded,
  earthMarker: IconEarthMarker,
  edit: IconEdit,
  emptySectionSitting: EmptySectionSitting,
  emptySectionStanding: EmptySectionStanding,
  exclude: IconExclude,
  explore: IconExplore,
  file: IconFile,
  find: IconFind,
  fundamentals: IconFundamentals,
  grid: IconGrid,
  gridCompany: GridCompany,
  gridLarge: IconGridLarge,
  healthcare: GridHealthcare,
  info: IconInfo,
  infoOutline: IconInfoOutline,
  investor: IconInvestor,
  leasing: IconLeasing,
  leasingTrends: IconLeasingTrends,
  link: IconLink,
  list: IconList,
  map: IconMap,
  mapMarker: IconMapMarker,
  mapPin: IconMapPin,
  mapPinDark: IconMapPinDark,
  merge: IconMerge,
  minus: IconMinus,
  more: IconMore,
  nearbyAmenities: IconNearbyAmenities,
  note: IconNote,
  occupier: IconOccupier,
  parcel: Parcel,
  performance: IconPerformance,
  plus: IconPlus,
  privacy: IconPrivacy,
  profilePicture: IconProfilePicture,
  ranking: IconRanking,
  recreationParks: IconRecreationParks,
  rectangle: IconRectangle,
  sale: IconSale,
  schools: IconSchools,
  search: IconSearch,
  send: IconSend,
  share: IconShare,
  spaces: IconSpaces,
  stack: IconStack,
  star: IconStar,
  temple: IconTemple,
  tenantProspect: IconTenantProspect,
  theater: IconTheater,
  tertiaryPoint: IconTertiaryPoint,
  times: IconTimes,
  touring: IconTouring,
  tourOverview: TourOverview,
  upload: IconUpload,
  user: IconUser,
  walkscoreBike: IconWalkscoreBike,
  walkscoreCopy: IconWalkscoreCopy,
  walkscoreTransit: IconWalkscoreTransit,
  walkscoreWalk: IconWalkscoreWalk,
  warning: IconWarning,
  world: IconWorld,
};

export const FLAGS_ICONS: { [name: string]: string } = {
  CA: CAFlag,
  DE: DEFlag,
  IE: IEFlag,
  IL: ILFlag,
  KR: KRFlag,
  MX: MXFlag,
  PL: PLFlag,
  RO: ROFlag,
  UK: UKFlag,
  US: USFlag,
};

export const GREATER_MARKET_IMAGES: { [key: string]: string } = {
  'Z - Greater US': GreaterUS,
  'Z - Greater Germany': GreaterGermany,
  'Z - Greater United Kingdom': GreaterUK,
  'Z - Greater Canada': GreaterCanada,
  'Z - Greater Israel': GreaterIsrael,
  'Z - Greater Ireland': GreaterIreland,
  'Z-Global': Global,
  'Z - Greater Poland': GreaterPoland,
};
